// @ts-nocheck
import { map } from "rxjs/operators";
import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Rates } from '../model';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-rates',
  templateUrl: './rates.component.html',
  styleUrls: ['./rates.component.css']
})

export class RatesComponent implements OnInit {

  rates: Observable<Rates>

  constructor(public db: AngularFireDatabase) {}

  ngOnInit() {
    this.rates = this.db.object("averageRatesInUsd/latest").valueChanges().map( values => {
      return new Rates(values["HEK"], values["TBR"], values["RND"])
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/rates/rates.component.ts